var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgDeleteQuestion = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.343 3.2h-2.408V1.7c0-.662-.54-1.2-1.204-1.2H4.714c-.664 0-1.204.538-1.204 1.2v1.5H1.102a.6.6 0 0 0-.602.6v.6c0 .082.068.15.15.15h1.136l.465 9.806c.03.64.56 1.144 1.202 1.144h8.539a1.2 1.2 0 0 0 1.201-1.144l.465-9.806h1.136a.15.15 0 0 0 .15-.15v-.6a.6.6 0 0 0-.601-.6Zm-3.762 0H4.863V1.85h5.718V3.2Z",
    fill: "red"
  })));
};
export { SvgDeleteQuestion as ReactComponent };
export default __webpack_public_path__ + "d725598f5b97b60219a98aa429b6f291.svg";